import React, { useState } from 'react';


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar gray-text">
      <div className="navbar-container">
        <button className="navbar-toggle" onClick={toggleMenu}>
          <span className="navbar-icon"></span>
          <span className="navbar-icon"></span>
          <span className="navbar-icon"></span>
        </button>
        <ul className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <li className="navbar-item"><a href="#home">صفحه اصلی</a></li>
          <li className="navbar-item"><a href="#about">درباره ما</a></li>
          <li className="navbar-item"><a href="#services">فروشگاه</a></li>
        </ul>
        <div className="navbar-logo">
          <button class="btn-app fw-600" onClick={() => window.location.href = "https://cafebazaar.ir/app/app.golet.app"}
          >دانلود گُلت</button>
        </div>
      </div>
    </nav>
  );
};


export default Navbar;
